import Konva from 'konva';
export function getBrightness(color) {
    const { r, g, b } = Konva.Util.colorToRGBA(color);
    return (r * 299 + g * 587 + b * 114) / 1000;
}
